import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-login-icon]',
  template: `
    <svg:path
      d="M16.3119 0.0155096C18.2862 -0.164869 19.9998 1.25114 20 3.06387V16.9351C20 18.7481 18.2864 20.1649 16.3119 19.9845L9.60388 19.372C7.88935 19.2154 6.58398 17.8969 6.58396 16.3227V15.1067C6.58418 14.5428 7.08464 14.0853 7.70196 14.0853C8.31916 14.0854 8.81974 14.5428 8.81997 15.1067V16.3227C8.81999 16.8474 9.25509 17.2869 9.82661 17.3391L16.5346 17.9516C17.1927 18.0117 17.764 17.5394 17.764 16.9351V3.06387C17.7637 2.45981 17.1926 1.98741 16.5346 2.04742L9.82661 2.66088C9.25508 2.7131 8.81997 3.15257 8.81997 3.67734V4.89229C8.81997 5.45635 8.3193 5.91361 7.70196 5.91374C7.08451 5.91374 6.58396 5.45642 6.58396 4.89229V3.67734C6.58396 2.10307 7.88935 0.784666 9.60388 0.627976L16.3119 0.0155096Z"
    />
    <svg:path
      d="M11.9705 14.8076C11.5339 15.2062 10.8261 15.2064 10.3896 14.8076C9.95307 14.4089 9.95329 13.7622 10.3896 13.3633L12.9531 11.0211L1.118 11.0211C0.500799 11.021 0.000222368 10.5636 0 9.99969C-5.39727e-08 9.43564 0.500662 8.97837 1.118 8.97825L12.9531 8.97825L10.3896 6.63612C9.95307 6.23732 9.95329 5.59066 10.3896 5.19173C10.8262 4.79284 11.5339 4.79284 11.9705 5.19173L16.4425 9.2775C16.879 9.6764 16.8791 10.323 16.4425 10.7219L11.9705 14.8076Z"
    />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginIcon {
  readonly viewBox = input<string>('0 0 20 20');
  readonly extraClass = input<string>('');
}
